import { TRIP_TABS, type TripTab } from '../trips.paths';

interface TripTabInputs {
  hasDriver: boolean;
  canViewHistory: boolean;
  canViewCash: boolean;
  canTopUp: boolean;
  /** The Record for driver tab: a capture is on offer (`availableTripActions`). */
  canCapture: boolean;
}

/**
 * The tabs this user has use for. History needs `audit.view`, Cash a cash permission, and Record for driver a driver to record for;
 * a tab the user would only meet empty or refused is not offered. Navigation hiding is UX: the server refuses what it must.
 */
export function visibleTripTabs(inputs: TripTabInputs): TripTab[] {
  return TRIP_TABS.filter((tab) => {
    if (tab === 'history') return inputs.canViewHistory;
    if (tab === 'cash') return inputs.canViewCash || inputs.canTopUp;
    if (tab === 'record') return inputs.canCapture;
    if (tab === 'messages') return inputs.hasDriver;
    return true;
  });
}
